export default __webpack_public_path__ + "static/media/illustration_market-model.187c528b.png";